<script lang="ts">
  import { getContext } from 'svelte';
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import './css/badges.scss';
  import type { Badges } from '../types';
  import type { MktSettings } from 'customer-components/lib/types';

  export let properties: Badges;
  export let settings: MktSettings;

  const isEditable = getContext<boolean>('isEditable') || false;

  $: ({ button, callouts, description, headline, images } = properties);
  $: ({ numberOfReviews } = settings);
</script>

<section class="badges">
  <div class="wrapper">
    <div class="badges-top">
      <h2 class="h2">{@html headline?.value}</h2>
      <p class="sub-text">
        {@html description?.value}
      </p>
    </div>

    <div class="badge-list">
      {#each images as image}
        <div class="badge">
          <img
            loading="lazy"
            src={image}
            alt="recognition of a locally owned business"
          />
        </div>
      {/each}
    </div>
    <div class="badges-bottom">
      <a href="#testimonials-section" class="google-reviews-box">
        <p>{numberOfReviews} Reviews</p>
        <div class="devider" />
        <img
          src="https://voolt-template-asset.b-cdn.net/u-15477/w-6345/cHdTvqruSUi8ARQeRJVzLg_google-logo.png"
          alt="Google logo"
          loading="lazy"
          width="51"
          height="16"
        />
      </a>
      {#if button?.label?.length}
        <div class="bottom-boxes">
          <a
            id="badges-book-now"
            class="primary-button open-form-js"
            target={button.link_type === 'External' ? '_blank' : ''}
            href={getHref(button.link_type, button.link)}
            >{@html button.label}</a
          >
          <div class="small-text-box">
            {#each callouts.value as item}
              <div>
                <BulletPoint bulletIcon={callouts?.icon} />
                <p class="text-small">{@html item}</p>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</section>
